(function(){
  var root=document.querySelector('[data-pp-root]');
  if(!root){return;}
  var panel=root.querySelector('[data-pp-panel]');
  if(panel){panel.classList.add('pp-reveal');}
  document.documentElement.classList.add('pp-js');

  function place(){
    var info=document.querySelector('.product__info-container');
    var form=info&&info.querySelector('.product-form, product-form');
    if(!info||!form||!panel){return;}
    var anchor=form;
    while(anchor.parentElement&&anchor.parentElement!==info){anchor=anchor.parentElement;}
    anchor.insertAdjacentElement('afterend',panel);
    panel.classList.remove('pp-panel--fallback');
  }
  place();

  if(panel){
    if('IntersectionObserver' in window){
      var rio=new IntersectionObserver(function(entries){
        entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');rio.unobserve(e.target);}});
      },{threshold:0.12});
      rio.observe(panel);
    }else{panel.classList.add('is-in');}
  }

  var bar=root.querySelector('[data-pp-sticky]');
  var btn=bar&&bar.querySelector('[data-pp-sticky-btn]');
  var priceEl=bar&&bar.querySelector('[data-pp-sticky-price]');
  var submit=document.querySelector('.product-form__submit');

  function sync(){
    if(!bar||!submit){return;}
    var p=document.querySelector('.product__info-container .price .price-item--last');
    if(p&&priceEl){priceEl.textContent=p.textContent.trim();}
    var off=submit.disabled||submit.hasAttribute('disabled');
    btn.disabled=off;
    btn.textContent=off?'Unavailable':btn.getAttribute('data-label');
  }

  if(bar&&btn&&submit&&'IntersectionObserver' in window){
    var sio=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var show=!e.isIntersecting&&e.boundingClientRect.top<0;
        bar.classList.toggle('is-visible',show);
        bar.setAttribute('aria-hidden',show?'false':'true');
        btn.tabIndex=show?0:-1;
        if(show){sync();}
      });
    },{threshold:0});
    sio.observe(submit);
    btn.addEventListener('click',function(){if(!btn.disabled){submit.click();}});
    var info2=document.querySelector('.product__info-container');
    if(info2&&'MutationObserver' in window){
      var t;
      new MutationObserver(function(){clearTimeout(t);t=setTimeout(sync,150);}).observe(info2,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    }
    sync();
  }

  document.addEventListener('pointerdown',function(e){
    var b=e.target.closest&&e.target.closest('.product-form__submit, .shopify-payment-button__button--unbranded');
    if(!b||b.disabled){return;}
    var r=b.getBoundingClientRect();
    var d=Math.max(r.width,r.height);
    var s=document.createElement('span');
    s.className='pp-ripple';
    s.style.cssText='width:'+d+'px;height:'+d+'px;left:'+(e.clientX-r.left-d/2)+'px;top:'+(e.clientY-r.top-d/2)+'px';
    b.appendChild(s);
    setTimeout(function(){if(s.parentNode){s.parentNode.removeChild(s);}},700);
  });
})();
